import axios from "axios";
import {
  loginRequest,
  loginSuccess,
  loginFail,
  clearError,
  loadUserRequest,
  loadUserSuccess,
  loadUserFail,
  logoutsuccess,
} from "../slices/authSlices";
import { toast } from "react-toastify";
import { mainurl } from "./mainurl";

const baseUrl = mainurl

export const LoginUser = (value) => async (dispatch) => {
  try {
    dispatch(loginRequest());
    const { data } = await axios.post(`${baseUrl}/auth/login`, value, {
      withCredentials: true,
    });
    dispatch(loginSuccess(data));
    toast(`you login as ${data.user.role}`);
  } catch (error) {
    dispatch(loginFail(error.response.data.message));
  }
};

export const LoadUser = async (dispatch) => {
  try {
    dispatch(loadUserRequest());
    const { data } = await axios.get(`${baseUrl}/auth/myprofile`, {
      withCredentials: true,
    });
    dispatch(loadUserSuccess(data));
  } catch (error) {
    if (error.message === "Network Error") {
      return dispatch(loadUserFail("Network Error"));
    }
    dispatch(loadUserFail(error.response.data.message));
  }
};

export const LogOutUser = async (dispatch) => {
  try {
    await axios.get(`${baseUrl}/auth/logout`, {
      withCredentials: true,
    });
    dispatch(logoutsuccess());
    window.location.href = "/login";
    toast.success(`Logged out successfully`);
  } catch (error) {
    console.log(error);
  }
};

export const clearAuthError = (dispatch) => {
  dispatch(clearError());
};
